import {
  Datagrid,
  Edit,
  List,
  SaveButton,
  SimpleForm,
  TextField,
  Toolbar,
  EditButton,
  BooleanField,
  NullableBooleanInput,
  DateField,
  ImageField
} from "react-admin";

export const RequestList = (props) => {
  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField source="user.phonenumber" />
        <TextField source="auction_id" />
        <TextField source="auction.description" />
        <DateField source="created_at" label="Date" />
        <BooleanField source="approved" />
        <EditButton></EditButton>
      </Datagrid>
    </List>
  );
};

const UserEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

export const RequestEdit = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm toolbar={<UserEditToolbar />}>
        <NullableBooleanInput label="approved" source="approved" />
      </SimpleForm>
    </Edit>
  );
};
